<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>一致性檢查</span>
                        <h1>讓您的寫作更加專業</h1>
                        <p>只需按一下幾下即可實現專業的定稿，為您節省大量的時間。Trinka的一致性檢查將幫助您修訂難以發現的不一致之處，特別是文檔比較冗長的情況。</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=TW" id="autoEditGetStart" target="_blank">開始使用</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/Consistency-Checks.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/ConsistencyCheckThumbnail.png" alt="" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>看它是如何工作的</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">查看簡單的示範影片，立即開始使用一致性檢查功能。</p>
                        <p style="margin-bottom: 10px;">這個詳細的分步教程可幫助您充分利用Trinka的強大功能。如果您有更多問題，請在
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">此處</a>瀏覽我們的常見問題解答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Trinka一致性檢查的主要特點</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka能夠發現寫作不一致的地方，讓你的寫作看起來更加地專業。Trinka能夠識別並糾正以下類型的寫作不一致：
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards  ">
                        <div class="feature_num">01</div>
                        <h3>拼寫</h3>
                        <p class="fearureCardText">Trinka可以識別同一單詞的不同拼寫，比如
                            <span>美式與英式</span> 。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="colourSection" name="spellingchecks" checked>
                                <label for="colourSection">colour (4 occurences) </label>
                            </p>
                            <p>
                                <input type="radio" id="colorSections" name="spellingchecks">
                                <label for="colorSections">color (4 occurences) </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">02</div>
                        <h3>連字號和破折號</h3>
                        <p class="fearureCardText">Trinka能夠發現
                            <span>連字號和破折號</span> 的使用不一致。只需按一下滑鼠，就可以完成更改，使它們保持一致。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                <label for="ultra-violet">ultra-violet (5 occurrences)
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="ultra_violet" name="dashesCehcks">
                                <label for="ultra_violet">ultra violet (5 occurrences)
                                </label>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards ">
                        <div class="feature_num">03</div>
                        <h3>編號樣式</h3>
                        <p class="fearureCardText">
                            <span>使用數字和拼寫數字</span>是最常見的不一致之一。只需按一下滑鼠，Trinka就可以説明您避免它。</p>
                        <div class="custom_radioButtons">
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks" checked>
                                    <label for="averagesixyears">
                                        <b>average six years</b>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <b>average 6 years</b>
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="averagesixyears" name="sadfdashesCehcks">
                                    <label for="averagesixyears">
                                        <b>average 6 years</b>
                                        <img src="../../../assets/images/spacingArrow.png" />
                                        <b>average six years</b>
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">04</div>
                        <h3>符號</h3>
                        <p class="fearureCardText">Trinka能夠理解您交替
                            <span>使用符號或將它們拼出來</span>的這種不一致。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFourContent_one" name="exampeFourContent" checked>
                                <label for="exampeFourContent_one">
                                    <b>TNF-alpha"</b>
                                    <img src="../../../assets/images/spacingArrow.png" />
                                    <b>tnf-α"</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFourContent_two" name="exampeFourContent">
                                <label for="exampeFourContent_two">
                                    <b>tnf-α"</b>
                                    <img src="../../../assets/images/spacingArrow.png" />
                                    <b>TNF-alpha"</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="feature_num">05</div>
                        <h3>間距</h3>
                        <p class="fearureCardText">寫作中多餘的空格很難發現，因此很容易錯過。只需在Trinka中按一下幾下，即可幫助您消除整個寫作過程中
                            <span>不一致的間距</span> 。</p>
                        <div class="custom_radioButtons">
                            <p>
                                <input type="radio" id="exampeFiveContent_one" name="exampeFiveContent" checked>
                                <label for="exampeFiveContent_one">
                                    <b>p
                                        <0</b>
                                            <img src="../../../assets/images/spacingArrow.png" />
                                            <b>p
                                                < 0</b>
                                </label>
                            </p>
                            <p>
                                <input type="radio" id="exampeFiveContent_two" name="exampeFiveContent">
                                <label for="exampeFiveContent_two">
                                    <b>p
                                        < 0</b>
                                            <img src="../../../assets/images/spacingArrow.png" />
                                            <b>p
                                                <0</b>
                                </label>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="cloud_key_features toolbox_img_content">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>View a Sample Report</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Dashes</h2>
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="ultra-violet" name="dashesCehcks" checked>
                                    <label for="ultra-violet">ultra-violet (5 occurrences)
                                    </label>
                                </p>
                                <p>
                                    <input type="radio" id="ultra_violet" name="dashesCehcks">
                                    <label for="ultra_violet">ultra violet (5 occurrences)
                                    </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Spacing</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="addSpaicng" name="spacingChecks" checked>
                                    <label for="addSpaicng">Add space</label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>p
                                        <0 <img src="../../../assets/images/spacingArrow.png" /> p
                                        < 0 </li>
                                            <li>p=0
                                                <img src="../../../assets/images/spacingArrow.png" />p = 0 </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Numbers</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="spelledOut" name="numberschecks" checked>
                                    <label for="spelledOut">Spelled-out
                                        <img src="../../../assets/images/spacingArrow.png" /> Numeral
                                    </label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>average six years
                                        <img src="../../../assets/images/spacingArrow.png" />average 6 years </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Spelling</h2>
                            <div class="custom_radioButtons">
                                <p>
                                    <input type="radio" id="colourSection" name="spellingchecks" checked>
                                    <label for="colourSection">colour (4 occurences) </label>
                                </p>
                                <p>
                                    <input type="radio" id="colorSections" name="spellingchecks">
                                    <label for="colorSections">color (4 occurences) </label>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <div class="consistency_right_text">
                            <h2>Greek Letter Style</h2>
                            <div class="custom_radioButtons">
                                <p style="margin: 0;">
                                    <input type="radio" id="GreekSpelledOut" name="Greekletterstyle" checked>
                                    <label for="GreekSpelledOut">Spelled-out
                                        <img src="../../../assets/images/spacingArrow.png" /> Symbol
                                    </label>
                                </p>
                                <ul style="margin-bottom: 20px;">
                                    <li>TNF-alpha"
                                        <img src="../../../assets/images/spacingArrow.png" />tnf-α"
                                    </li>
                                    <li>"Beta particles
                                        <img src="../../../assets/images/spacingArrow.png" />"β particles
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div> -->
    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>確保你寫作的一致和專業</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">開始使用</a>
            </div>
        </div>
    </div>
    <!-- <div class="forpersonlized_sections">
        <p>Experience Advanced Writing Assistance</p>
        <div class="forpersonlizedFooter">
            <a href="https://cloud.trinka.ai/signup?_rg=TW" target="_blank">Get Started</a>
        </div>
    </div> -->
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常見問題</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Trinka的一致性檢查是如何工作的？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka的一致性檢查會自動查找幾種常見的寫作不一致，為您列出所有內容，並且為您提供更正選項。您只需選擇正確的樣式並確認，Trinka將為您完成剩下的更改。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">我在哪裡可以找到一致性檢查功能？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>一致性檢查功能目前在雲編輯器上供所有用戶使用。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        使用一致性檢查功能是否消耗積分？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>目前使用一致性檢查功能不需要花費積分。您可以根據需要多次使用該功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我應該何時使用一致性檢查功能？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>理想情況下，您應該在寫作完成後運行一致性檢查功能。但您可以在需要的時候多次運行這個功能。
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        使用Trinka的一致性檢查修復寫作中的不一致
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>使用Trinka的一致性檢查，只需按一下幾下滑鼠即可為您節省時間，並讓您的寫作更加專業。
                                        </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他應用程式
                                    <br />中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/tw/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="browser">
                                            <h3>瀏覽器
                                                <br />外掛程式</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/tw/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise apps">
                                            <h3 style="margin: 0 0 -2px 0;">企業</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/hTaMLLHICCo"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>